import * as t from 'ts-schema';
import { registerQuery } from 'data-fetching-client';
import { getCollectionItems } from '../../clients/qualityClient';
export function registerCollectionItemsQuery({
  offeringType,
  fieldName,
  schema
}) {
  return registerQuery({
    fieldName,
    args: ['appContext', 'collectionId', 'language', 'length', 'offset'],

    fetcher({
      appContext,
      collectionId,
      language,
      length,
      offset
    }) {
      return getCollectionItems({
        appContext,
        collectionId,
        language,
        length,
        offeringType,
        offset
      }).then(resp => t.assert(schema, resp));
    }

  });
}